module.exports = "/assets/data/d8fd6fdf55a58860a44ed4397b9ff17f-GU30.data.json";